import { belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  endorser: belongsTo('user', { async: false }),
  endorsee: belongsTo('user', { async: false }),
  skill: belongsTo('skill', { async: false }),
});
